import Vue from 'vue';
import investmentFund from './investment-fund/investment-fund.vue';
Vue.component('investment-fund', investmentFund);
